import React from "react";
import "./CandidateFormHeader.css";

const CandidateFormHeader = () => {
  return (
    <section className="CandidateFormHeader-container">
      <div className="CandidateFormHeader-overlay">
        <div className="container" style={{ textAlign: "center" }}>
          <h1 className="CandidateFormHeader-title">For Candidates</h1>
          <div className="CandidateFormHeader-breadcrumb">
            <button className="btn btn-primary">
              Home - Candidate Application Form
            </button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CandidateFormHeader;
